import React, { useState } from "react";

import { CreditCard, Phone, ShieldCheck, MapPin, Menu, X } from "lucide-react";

import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="navbar-container">
        {/* LOGO */}

        <a href="/" className="navbar-logo">
          <div className="logo-icon">
            <CreditCard size={35} strokeWidth={2.8} />
          </div>

          <div className="logo-text">
            <span className="logo-title">RÚT THẺ NHANH</span>

            <span className="logo-subtitle">
              Rẻ - An toàn - Uy tín - Bảo mật
            </span>
          </div>
        </a>

        {/* NAVBAR DESKTOP */}

        <div className="navbar-info">
          <div className="navbar-item">
            <Phone className="navbar-item-icon" />

            <div className="navbar-item-text">
              <strong>Hỗ trợ 24/7</strong>

              <span>Có mặt tận nơi</span>
            </div>
          </div>

          <div className="navbar-item">
            <ShieldCheck className="navbar-item-icon" />

            <div className="navbar-item-text">
              <strong>Bảo mật thông tin</strong>

              <span>Cam kết an toàn</span>
            </div>
          </div>

          <div className="navbar-item">
            <MapPin className="navbar-item-icon" />

            <div className="navbar-item-text">
              <strong>Phục vụ khu vực</strong>

              <span>TPHCM</span>
            </div>
          </div>
        </div>

        {/* BUTTON CALL */}

        <a href="tel:0941342598" className="navbar-call">
          <Phone size={22} fill="white" />

          <div className="navbar-call-text">
            <strong>GỌI NGAY</strong>

            <span>0941 342 598</span>
          </div>
        </a>

        {/* MOBILE MENU BUTTON */}

        <button
          className="navbar-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? "Đóng menu" : "Mở menu"}
          aria-expanded={menuOpen}
          aria-controls="navbar-mobile-menu"
        >
          {menuOpen ? <X size={27} /> : <Menu size={27} />}
        </button>
      </div>

      {/* MOBILE MENU */}

      <div
        id="navbar-mobile-menu"
        className={`navbar-mobile ${menuOpen ? "active" : ""}`}
      >
        <div className="mobile-item">
          <Phone size={22} />

          <div>
            <strong>Hỗ trợ 24/7</strong>

            <span>Có mặt tận nơi</span>
          </div>
        </div>

        <div className="mobile-item">
          <ShieldCheck size={22} />

          <div>
            <strong>Bảo mật thông tin</strong>

            <span>Cam kết an toàn</span>
          </div>
        </div>

        <div className="mobile-item">
          <MapPin size={22} />

          <div>
            <strong>Phục vụ toàn quốc</strong>

            <span>Hà Nội | TPHCM | Các tỉnh</span>
          </div>
        </div>

        <a href="tel:0941342598" className="mobile-call">
          <Phone size={20} />
          GỌI NGAY: 0941 342 598
        </a>
      </div>
    </header>
  );
};

export default Navbar;
